export const LOADER_MATRIX_NINE_BOXES          = 'LOADER_MATRIX_NINE_BOXES';
export const GET_MATRIX_NINE_BOXES             = 'GET_MATRIX_NINE_BOXES';
export const MATRIX_NINE_BOXES_FAIL            = 'MATRIX_NINE_BOXES_FAIL';
export const SAVE_LOADER_MATRIX_NINE_BOXES     = 'SAVE_LOADER_MATRIX_NINE_BOXES';
export const FORM_MATRIX_NINE_BOXES_FAIL       = 'FORM_MATRIX_NINE_BOXES_FAIL';

